import  axios from "axios"
import {environment} from '../../environments/environment';
  export const axiosInstance = axios.create({
  baseURL: environment.baseUrl,
  headers:{"Authorization":localStorage.getItem('token')},
  timeout: 200000
});
